import {
  Comment,
  CommentId,
  CommentsById,
  isDirectBotComment,
  isDirectIntentComment,
  isDirectStepComment,
  isReplyComment
} from '../../../features/serverComments'
import { CommentGroupDescriptor } from './types'

export const determineGroupForComment = (
  allComments: CommentsById,
  testedId: CommentId
): CommentGroupDescriptor => {
  const comment = allComments[testedId!]

  if (!comment) {
    // Gracefully handling the case where comments from server are not yet loaded
    return { type: 'step', id: 'NON_EXISTENT_STEP' }
  }

  if (isReplyComment(comment)) {
    return determineGroupForComment(allComments, comment.inReplyTo)
  }

  if (isDirectBotComment(comment)) {
    return { type: 'bot' }
  }

  if (isDirectStepComment(comment)) {
    return { type: 'step', id: comment.stepId }
  }

  if (isDirectIntentComment(comment)) {
    return { type: 'intent', id: comment.intentId }
  }

  throw new Error('This will never happen (just wait for it...)')
}

export const getCommentsForGroup = (comments: Comment[], group: CommentGroupDescriptor) => {
  const { type: groupType } = group

  if (groupType === 'bot') {
    return comments.filter(isDirectBotComment)
  }

  if (groupType === 'step') {
    return comments.filter(comment => isDirectStepComment(comment) && comment.stepId === group.id)
  }

  if (groupType === 'intent') {
    return comments.filter(
      comment => isDirectIntentComment(comment) && comment.intentId === group.id
    )
  }
}

export const isCommentRelatingToNonExistentStep = (
  allComments: CommentsById,
  existingStepIds: string[],
  testedCommentId: CommentId
): boolean => {
  const groupForComments = determineGroupForComment(allComments, testedCommentId)

  if (groupForComments.type !== 'step') {
    return false
  }

  return !existingStepIds.includes(groupForComments.id)
}
